var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "payment-icons" }, [
    _c("img", {
      staticClass: "payment-icons__icon",
      attrs: { src: _vm.src, alt: "payment-icon" }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }